// extracted by css-extract-rspack-plugin
export default {"lovedHeart":"OverviewFeedback-module__lovedHeart__yOUXJ","loveAnimation":"OverviewFeedback-module__loveAnimation__iO4uR","heartPop":"OverviewFeedback-module__heartPop__lfuaG"};